var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMyFeedbackActive = function SvgMyFeedbackActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(7.5 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.273 14v-1.556c0-1.718-1.466-3.11-3.273-3.11H3.273C1.465 9.333 0 10.725 0 12.443V14"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.136,
    cy: 3.111,
    rx: 3.273,
    ry: 3.111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.09 6.222l1.637 1.556L17 4.667"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMyFeedbackActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/my-feedback-active.b0df01419a94a222c919be6e5e6dd864.svg";